import { useEffect, useState } from "react";
import { fetchAdmins } from "../../utils/wellspoken.api"
import { createOrEditAdmin } from "../../utils/wellspoken.api";
import toast from "react-hot-toast";

const ViewAdmin = () => {
    const [admins, setAdmins] = useState([]);
    const [editingAdmin, setEditingAdmin] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const loadAdmins = async () => {
            try {
                const response = await fetchAdmins();

                // API returns array directly
                const normalized = response.map((item) => ({
                    id: item.userId,        // ✅ correct for React keys / tables
                    name: item.name,
                    email: item.email,
                    mobile: item.mobile,
                    isActive: item.isActive,
                    isApproval: item.isApproval,
                    createDate: item.createDate,
                }));


                setAdmins(normalized);
            } catch (error) {
                console.error("Failed to fetch admins", error);
            }
        };

        loadAdmins();
    }, []);

    // const handleDelete = (id) => {
    //     setAdmins((prev) => prev.filter((admin) => admin.id !== id));
    // };

    const handleEditSave = async (e) => {
        e.preventDefault();

        // ✅ STEP 2.1: Build payload EXACTLY like backend expects
        const payload = {
            UserId: editingAdmin.id,   // backend expects string
            Name: editingAdmin.name,
            Email: editingAdmin.email,
            Mobile: editingAdmin.mobile,
            IsActive: editingAdmin.isActive,
            IsApproval: true,
            EntityId: editingAdmin.EntityId,
        };

        try {
            // ✅ STEP 2.2: Send payload to API
            await createOrEditAdmin(payload);
            toast.success("Updated successfully!")


            // 2️⃣ Fetch fresh data AFTER edit
            await fetchAdmins();

            // ✅ STEP 2.3: Update UI after success
            setAdmins((prev) =>
                prev.map((admin) =>
                    admin.id === editingAdmin.id ? editingAdmin : admin
                )
            );
            setIsModalOpen(false);
            setEditingAdmin(null);

        } catch (error) {
            console.error("Admin save failed:", error);
        }
    };


    return (
        <main className="bg-surface min-h-screen  px-4">
            <section
                aria-labelledby="admin-heading"
                className="max-w-6xl mx-auto"
            >
                <h1
                    id="admin-heading"
                    className="text-3xl sm:text-4xl text-center font-bold text-textPrimary mb-6"
                >
                    View Admins
                </h1>

                {/* Admin Table */}
                <div className="overflow-x-auto bg-white rounded-xl shadow-sm border border-border">
                    <table className="w-full text-sm text-left">
                        <caption className="sr-only">List of admins</caption>
                        <thead className="bg-surface text-textSecondary">
                            <tr>
                                <th scope="col" className="px-6 py-3">Name</th>
                                <th scope="col" className="px-6 py-3">Email</th>
                                <th scope="col" className="px-6 py-3">Mobile</th>
                                <th scope="col" className="px-6 py-3">Status</th>
                                <th scope="col" className="px-6 py-3">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y">
                            {admins.map((admin) => (
                                <tr key={admin.id} className="hover:bg-surface">
                                    <td className="px-6 py-4 text-textPrimary font-medium">
                                        {admin.name}
                                    </td>
                                    <td className="px-6 py-4 text-textSecondary">
                                        {admin.email}
                                    </td>
                                    <td className="px-6 py-4">{admin.mobile}</td>
                                    {/* <td className="px-6 py-4">{admin.status}</td> */}
                                    <td className="px-6 py-4">
                                        {admin.isActive ? "Active" : "Inactive"}
                                    </td>
                                    <td className="px-6 py-4 flex gap-3">
                                        <button
                                            onClick={() => {
                                                setEditingAdmin(admin);
                                                setIsModalOpen(true);
                                            }}
                                           className="w-full sm:w-auto rounded-xl
                       bg-gradient-to-r from-blue-600 to-indigo-600
                       px-6 py-3 text-white font-semibold
                       hover:from-blue-500 hover:to-indigo-500
                       focus-visible:outline-none
                       focus-visible:ring-2 focus-visible:ring-blue-500/40
                       disabled:opacity-60 transition"
                                            aria-label={`Edit ${admin.name}`}
                                        >
                                            Edit
                                        </button>
                                        {/* <button
                                            onClick={() => handleDelete(admin.id)}
                                            className="px-3 py-1.5 rounded-lg text-white bg-primary-light focus:outline-none focus:ring-2 focus:ring-primary-light"
                                            aria-label={`Delete ${admin.name}`}
                                        >
                                            Delete
                                        </button> */}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Edit Form */}
                {isModalOpen && editingAdmin && (
                    <div
                        role="dialog"
                        aria-modal="true"
                        className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4"
                    >
                        <div className="bg-white w-full max-w-lg rounded-xl shadow-lg border border-border">
                            {/* Header */}
                            <div className="flex justify-between items-center px-6 py-4 border-b">
                                <h2 className="text-lg font-semibold text-textPrimary">
                                    Edit Admin
                                </h2>
                                <button
                                    onClick={() => setIsModalOpen(false)}
                                    className="text-textSecondary hover:text-textPrimary"
                                    aria-label="Close modal"
                                >
                                    ✕
                                </button>
                            </div>

                            {/* Form */}
                            <form onSubmit={handleEditSave} className="p-6 grid gap-4">
                                {/* Name */}
                                <div>
                                    <label className="block text-sm text-textSecondary mb-1">
                                        Name
                                    </label>
                                    <input
                                        type="text"
                                        value={editingAdmin.name}
                                        onChange={(e) =>
                                            setEditingAdmin({ ...editingAdmin, name: e.target.value })
                                        }
                                        required
                                        className="w-full px-3 py-2 border border-border rounded-lg  focus:ring-primary"
                                    />
                                </div>

                                {/* Email */}
                                <div>
                                    <label className="block text-sm text-textSecondary mb-1">
                                        Email
                                    </label>
                                    <input
                                        type="email"
                                        value={editingAdmin.email}
                                        readOnly
                                        onChange={(e) =>
                                            setEditingAdmin({ ...editingAdmin, email: e.target.value })
                                        }
                                        required
                                        className="mt-2 w-full rounded-lg border border-gray-300
                       bg-gray-100 px-4 py-2.5 text-gray-700
                       cursor-not-allowed"
                                    />
                                </div>

                                {/* Mobile */}
                                <div>
                                    <label className="block text-sm text-textSecondary mb-1">
                                        Mobile
                                    </label>
                                    <input
                                        type="text"
                                        value={editingAdmin.mobile}
                                        onChange={(e) =>
                                            setEditingAdmin({ ...editingAdmin, mobile: e.target.value })
                                        }
                                        className="w-full px-3 py-2 border border-border rounded-lg  focus:ring-primary"
                                    />
                                </div>

                                {/* Status Dropdown */}
                                <div>
                                    <label className="block text-sm text-textSecondary mb-1">
                                        Status
                                    </label>
                                    <select
                                        value={editingAdmin.isActive ? "active" : "inactive"}
                                        onChange={(e) =>
                                            setEditingAdmin({
                                                ...editingAdmin,
                                                isActive: e.target.value === "active",
                                            })
                                        }
                                        className="w-full px-3 py-2 border border-border rounded-lg  focus:ring-primary"
                                    >
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                </div>

                                {/* Actions */}
                                <div className="flex justify-end gap-3 pt-4">
                                    <button
                                        type="button"
                                        onClick={() => setIsModalOpen(false)}
                                        className="px-5 py-2 rounded-lg border border-border"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                       className="w-full sm:w-auto rounded-xl
                       bg-gradient-to-r from-blue-600 to-indigo-600
                       px-6 py-3 text-white font-semibold
                       hover:from-blue-500 hover:to-indigo-500
                       focus-visible:outline-none
                       focus-visible:ring-2 focus-visible:ring-blue-500/40
                       disabled:opacity-60 transition"
                                    >
                                        Save Changes
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

            </section>
        </main>
    );
};

export default ViewAdmin;
